import { QuestionCircleOutlined } from "@ant-design/icons";
import { Button, Modal, Row } from "antd";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useRef } from "react";
import sectionService from "../../services/sections";
import SectionInfoDescriptionItem from "../sectionInfoDescription/item";

import "./style.scss";

const FoamModal = () => {
  const [visible, setVisible] = useState(false);
  const checkFirstLoad = useRef(1);
  const [dataFoam, setDataFoam] = useState<any>([]);

  useEffect(() => {
    if (checkFirstLoad.current === 1) {
      sectionService.getSection(
        "60668fd2e9e2acd45db099ce",
        (data: any, error) => {
          if (data) {
            setDataFoam(data?.data?.children);
          }

          if (error) {
            console.log(error);
          }
        }
      );
      checkFirstLoad.current--;
    }
  }, [visible]);

  const openModal = () => {
    setVisible(true);
  };
  const closeModal = () => {
    setVisible(false);
  };

  return (
    <>
      <Button
        className="foam-button"
        icon={<QuestionCircleOutlined />}
        onClick={openModal}
      />

      <Modal
        title="Thông tin chi tiết tỷ trọng mousse nệm"
        visible={visible}
        onCancel={closeModal}
        footer={null}
        width={930}>
        {dataFoam && dataFoam.length && (
          <Row justify="center" align="middle">
            {_.sortBy(dataFoam, ["order"]).map((item: any, i: number) => (
              <SectionInfoDescriptionItem item={item} />
            ))}
          </Row>
        )}
      </Modal>
    </>
  );
};

export default FoamModal;
